module.exports = __webpack_public_path__ + "static/media/id-card.92c110b3.png";